export const getMonthDayYearWithNoLeadingZeros = (timeGiven) => {
    const givenDate = new Date(timeGiven);
    const day = givenDate.getDate();
    const month = givenDate.getMonth();
    const year = givenDate.getFullYear().toString().substr(-2);
    return `${month + 1}/${day}/${year}`;
};

export default getMonthDayYearWithNoLeadingZeros;
